(() => {
  const timeZone = 'Europe/Berlin';
  const berlinParts = new Intl.DateTimeFormat('en-GB', {
    timeZone, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
  });
  const monthName = new Intl.DateTimeFormat('de-DE', { timeZone: 'UTC', month: 'long' });

  const partsAt = (timestamp) => Object.fromEntries(
    berlinParts.formatToParts(new Date(timestamp))
      .filter((part) => ['year', 'month', 'day', 'hour', 'minute'].includes(part.type))
      .map((part) => [part.type, Number(part.value)])
  );

  // Convert a Berlin calendar day to its UTC instant, including summer/winter time.
  const berlinMidnight = (year, month, day) => {
    const desired = Date.UTC(year, month - 1, day);
    let instant = desired;
    for (let attempt = 0; attempt < 3; attempt += 1) {
      const local = partsAt(instant);
      const shown = Date.UTC(local.year, local.month - 1, local.day, local.hour, local.minute);
      instant -= shown - desired;
    }
    return instant;
  };

  const readDate = (value) => {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
    if (!match) return null;
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const date = new Date(Date.UTC(year, month - 1, day));
    return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day
      ? { year, month, day } : null;
  };

  const shippingWindow = (year, month, root) => {
    const firstWeekday = new Date(Date.UTC(year, month - 1, 1)).getUTCDay();
    const firstMonday = 1 + ((8 - firstWeekday) % 7);
    let firstDay = firstMonday;
    let lastDay = firstMonday + 2;

    const overrideStart = readDate(root.dataset.overrideStart);
    const overrideEnd = readDate(root.dataset.overrideEnd);
    if (root.dataset.overrideMonth === `${year}-${String(month).padStart(2, '0')}` &&
        overrideStart && overrideEnd && overrideStart.year === year && overrideEnd.year === year &&
        overrideStart.month === month && overrideEnd.month === month &&
        overrideEnd.day >= overrideStart.day) {
      firstDay = overrideStart.day;
      lastDay = overrideEnd.day;
    }

    return {
      start: berlinMidnight(year, month, firstDay),
      end: berlinMidnight(year, month, lastDay + 1),
      label: `${firstDay}.–${lastDay}. ${monthName.format(new Date(Date.UTC(year, month - 1, 1)))} ${year}`
    };
  };

  const nextWindow = (now, root) => {
    const today = partsAt(now);
    let year = today.year;
    let month = today.month;
    let window = shippingWindow(year, month, root);
    if (now >= window.end) {
      month += 1;
      if (month > 12) { month = 1; year += 1; }
      window = shippingWindow(year, month, root);
    }
    return window;
  };

  const init = (root) => {
    if (root.dataset.countdownBound === 'true') return;
    root.dataset.countdownBound = 'true';

    const timer = root.querySelector('[data-countdown-timer]');
    const dates = root.querySelector('[data-countdown-dates]');
    const until = root.querySelector('[data-countdown-until]');
    const status = root.querySelector('[data-countdown-status]');
    const days = root.querySelector('[data-countdown-days]');
    const hours = root.querySelector('[data-countdown-hours]');
    const minutes = root.querySelector('[data-countdown-minutes]');

    const update = () => {
      const now = Date.now();
      const window = nextWindow(now, root);
      dates.textContent = window.label;
      document.querySelectorAll('[data-next-delivery]').forEach(target => {
        target.textContent = `Voraussichtliches Versandfenster: ${window.label}`;
      });

      if (now >= window.start) {
        timer.hidden = true;
        until.hidden = true;
        status.hidden = false;
        status.textContent = 'Die Versandwoche läuft.';
        return;
      }

      const remaining = Math.ceil((window.start - now) / 60000);
      days.textContent = String(Math.floor(remaining / 1440));
      hours.textContent = String(Math.floor((remaining % 1440) / 60)).padStart(2, '0');
      minutes.textContent = String(remaining % 60).padStart(2, '0');
      timer.hidden = false;
      until.hidden = false;
      status.hidden = true;
    };

    update();
    window.setInterval(update, 60000);
  };

  const initAll = () => document.querySelectorAll('[data-metzger-countdown]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
